module.exports = __webpack_public_path__ + "media/src/images/favicons/apple-touch-icon-57x57-76ee6719bdc50e4d4786194b063a2053.png";